export function dateStringToSortTime(value: string | null | undefined): number | null {
  if (value == null || !String(value).trim()) return null;
  const raw = String(value).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  if (m) {
    const t = Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    return Number.isFinite(t) ? t : null;
  }
  const t = Date.parse(raw);
  return Number.isFinite(t) ? t : null;
}

export function compareNullableTime(a: number | null, b: number | null, dir: 1 | -1): number {
  if (a == null && b == null) return 0;
  if (a == null) return 1;
  if (b == null) return -1;
  return dir * (a - b);
}

export function compareLocale(a: string, b: string, dir: 1 | -1): number {
  return dir * a.localeCompare(b, undefined, { sensitivity: 'base', numeric: true });
}
